import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { BRAND } from '../data/constants';
import { useApp } from '../data/ColisContext';

export default function Navbar() {
  const navigate  = useNavigate();
  const location  = useLocation();
  const { user, logout } = useApp();

  const isActive = (path) => location.pathname === path;

  const navBtnStyle = (path) => ({
    padding:      '8px 16px',
    borderRadius: 10,
    border:       'none',
    cursor:       'pointer',
    fontWeight:   600,
    fontSize:     13,
    fontFamily:   'inherit',
    background:   isActive(path) ? BRAND.gradient : '#EEF2FF',
    color:        isActive(path) ? 'white'        : BRAND.primary,
    transition:   'all 0.2s',
    display:      'flex',
    alignItems:   'center',
    gap:          6,
  });

  return (
    <nav style={{
      background:   'white',
      borderBottom: '1px solid #f0f0f0',
      padding:      '0 24px',
      height:       64,
      display:      'flex',
      alignItems:   'center',
      justifyContent: 'space-between',
      position:     'sticky',
      top:          0,
      zIndex:       100,
      boxShadow:    '0 1px 12px rgba(0,0,0,0.06)',
    }}>
      {/* Logo */}
      <button
        onClick={() => navigate('/')}
        style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 10 }}
      >
        <span style={{ fontSize: 28 }}>📦</span>
        <div style={{ textAlign: 'left' }}>
          <div style={{ fontSize: 18, fontWeight: 800, color: '#1e293b', letterSpacing: -0.5, lineHeight: 1.2 }}>
            Zaki<span style={{ color: BRAND.primary }}>Express</span>
          </div>
          <div style={{ fontSize: 11, color: '#94a3b8', fontWeight: 500 }}>Livraison · Dakar</div>
        </div>
      </button>

      {/* Actions */}
      <div style={{ display: 'flex', gap: 8 }}>
        <button onClick={() => navigate('/mes-colis')} style={navBtnStyle('/mes-colis')}>
          📦 Mes colis
        </button>
        <button onClick={() => navigate('/suivi')} style={navBtnStyle('/suivi')}>
          🔍 Suivi colis
        </button>

        {!user ? (
          <>
            <button onClick={() => navigate('/login')} style={navBtnStyle('/login')}>
              🔐 Connexion
            </button>
            <button onClick={() => navigate('/register')} style={navBtnStyle('/register')}>
              ✍️ Inscription
            </button>
          </>
        ) : (
          <button
            onClick={() => {
              logout();
              navigate('/');
            }}
            style={{
              padding: '8px 16px',
              borderRadius: 10,
              border: 'none',
              cursor: 'pointer',
              fontWeight: 700,
              fontSize: 13,
              fontFamily: 'inherit',
              background: '#FEE2E2',
              color: '#B91C1C',
              transition: 'all 0.2s',
              display: 'flex',
              alignItems: 'center',
              gap: 6,
            }}
          >
            🚪 Déconnexion
          </button>
        )}
      </div>
    </nav>
  );
}
